import LiteYouTubeEmbed from 'react-lite-youtube-embed';
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';

// Quarks
import Container from 'quarks/Container';
import Flex from 'quarks/Flex';
import type { FlexProps } from 'quarks/interpolations/flex';

import { getYoutubeId } from 'utils/functions';
import richTextParser from 'utils/richTextParser';

// Types
import type { ContentfulComponentCard } from 'graphqlTypes';
import type { FC } from 'react';

interface BasicCardProps
  extends FlexProps,
    Omit<ContentfulComponentCard, 'id' | 'children' | 'contentful_id' | 'internal' | 'node_locale'> {
  backgroundIsDark: boolean;
}

const BasicCard: FC<BasicCardProps> = ({ internalName, youTubeUrl, body, backgroundIsDark, ...props }) => {
  const youtubeID = getYoutubeId(youTubeUrl || '');

  return (
    <Flex
      width="100%"
      height="100%"
      flexDirection="column"
      borderRadius="12px"
      overflowX="hidden"
      overflowY="hidden"
      border="1px solid"
      borderColor="gray-200"
      hover={{ boxShadow: 'xxl' }}
      transition="200ms ease-in-out"
      backgroundColor={backgroundIsDark ? 'gray-900' : 'common-white'}
      {...props}
    >
      {youTubeUrl && (
        <Container
          width="100%"
          minHeight="184px"
          maxHeight="184px"
          overflowX="hidden"
          overflowY="hidden"
          css={`
            article {
              height: 100%;
            }
          `}
        >
          <LiteYouTubeEmbed id={youtubeID || ''} poster="hqdefault" webp title={internalName || ''} />
        </Container>
      )}
      <Flex
        position="relative"
        flexDirection="column"
        justifyContent="space-between"
        paddingAll={24}
        gap="16px"
        height="100%"
        maxHeight="fit-content"
        sm={{ maxHeight: 'calc(100% - 208px)' }}
      >
        {body && (
          <Flex
            width="100%"
            flexDirection="column"
            fontSize="textSm"
            lineHeight="textSm"
            textColor={backgroundIsDark ? 'gray-200' : 'gray-900'}
            gap="12px"
          >
            {richTextParser(body)}
          </Flex>
        )}
      </Flex>
    </Flex>
  );
};

export default BasicCard;
